import { reactive } from "vue";
import {
    type BreakpointInfo,
    getCurrentBreakpoint,
    observer,
} from "../responsive";

let observable: BreakpointObservableObject | undefined;

interface BreakpointObservableObject {
    currentBreakpoint: BreakpointInfo | undefined;
}

function createBlankValue() {
    return reactive({
        currentBreakpoint: getCurrentBreakpoint(),
    });
}

export function getBreakpointObservable() {
    if (observable == null) {
        observable = createBlankValue();
        observer.addEventListener("change", (event) => {
            if (observable == null) {
                observable = createBlankValue();
            }
            observable.currentBreakpoint = (
                event as CustomEvent<BreakpointInfo | undefined>
            ).detail;
        });
    }

    return observable;
}
